import { gql } from '@/Types/gql';

export const GET_CURRENT_USER = gql(`
  query GetCurrentUser {
    getCurrentUser {
      _id
      displayName
      email
      firstName
      lastName
      phoneNumber
      profileImage
      sessionBalance
      freeSessionBalance
      fitCurveBalance
      fitPrimeBalance
      fitVarsityBalance
      role
      status
    }
  }
`);

export const GET_TRAINER_RANDOM_LIST = gql(`query MeetOurTrainers {
  meetOurTrainers {
    _id
    firstName
    lastName
    dateOfBirth
    displayName
    profileImage(formats: { edits: { resize: { width: 132, height: 142, fit: "cover" } } })
    lazyLoadingAlt: profileImage(formats: { edits: { resize: { height: 20, fit: "contain" } } })
    gender
  }
}`);

export const GET_ALL_TRAINERS =
  gql(`query GetAllTrainers($limit: Int, $offset: Int, $filter: JSON, $sort: JSON) {
  getAllTrainers(limit: $limit, offset: $offset, filter: $filter, sort: $sort) {
    _id
    gender
    lastName
    firstName
    displayName
    profileImage
    averageRating
  }
  getAllTrainersCount(filter: $filter)
}`);

export const GET_ALL_SPECIALIZATIONS =
  gql(`query GetAllSpecialization($limit: Int, $offset: Int, $sort: JSON) {
  getAllSpecialization(limit: $limit, offset: $offset, sort: $sort) {
    _id
    title
  }
}`);

export const GET_SIGNED_URL = gql(`query GetSignedUrl($fileName: String!, $fileType: FileType!) {
  getSignedUrl(fileName: $fileName, fileType: $fileType) {
    key
    url
  }
}`);

export const GET_ALL_TRAINING_TYPE =
  gql(`query GetAllTrainingType($limit: Int, $offset: Int, $sort: JSON) {
  getAllTrainingType(limit: $limit, offset: $offset, sort: $sort) {
    _id
    order
    title
    icon
  }
}`);

export const GET_USER_BY_ID = gql(`query GetUserById($id: ID!) {
  getUserById(_id: $id) {
    _id
    email
    ageRange
    countryCode
    firstName
    lastName
    displayName
    profileImage
    countryCode
    phoneNumber
    fitPrimeBalance
    fitCurveBalance
    fitVarsityBalance
    freeSessionBalance
    dateOfBirth
    timezone
    gender
    height
    weight
    heightType
    weightType
    locationName
    languages
    fitnessGoals
    injury {
      description
      status
    }
    preferredWorkouts {
      _id
      title
    }
    equipments
    currentEngagements {
      description
      status
    }
    workoutPreference
    heardAboutUs
    about
    averageRating
    specializations {
      _id
      title
    }
    medias {
      _id
      path
      type
      thumbnail
    }
    socialMediaLinks {
      url
      platform
    }
    userCertificateCount
    userCertificates {
      _id
      filePath
      filePathUrl
      certificate {
        _id
        title
      }
    }
  }
}`);

export const GET_ALL_NOTIFICATIONS =
  gql(`query GetAllNotification($limit: Int, $offset: Int, $sort: JSON, $filter: JSON) {
  getAllNotification(limit: $limit, offset: $offset, sort: $sort, filter: $filter) {
    _id
    createdAt
    eventData
    eventType
    isRead
    message
    redirectPath
    sendFromId
    sendFromIdUser {
      _id
      displayName
      profileImage
    }
    title
  }
}`);

export const GET_ALL_NOTIFICATION_COUNT = gql(`query GetAllNotificationCount($filter: JSON) {
  getAllNotificationCount(filter: $filter)
}`);

export const GET_ALL_PROGRAM = gql(`query GetAllProgram($search: String, $filter: JSON, $sort: JSON, $limit: Int, $offset: Int) {
  getAllProgram(search: $search, filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    _id
    programName
    description
    status
    createdAt
  }
}`);

export const GET_ALL_SPORTS = gql(`query GetAllSports($search: String, $filter: JSON, $sort: JSON, $limit: Int, $offset: Int) {
  getAllSports(search: $search, filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    _id
    status
    sportName
    order
    updatedAt
    createdAt
  }
}`);
